<template>
  <v-data-table
    :footer-props="footer"
    :headers="headers"
    :items.sync="items"
    :loading="loading"
    :options.sync="options"
    :server-items-length="totalItems"
    class="elevation-0"
    item-key="id"
    sortable="false"
  >
    <template #item.name="{ item }">
      <p class="ma-0 text-left">
        {{ item.id }}#{{ item.name }}
      </p>
      <p class="text-left text-muted">
        {{ item.mobile }}
      </p>
    </template>
    <template #item.amount="{ item }">
      <span class="text-monospace text-right text-success d-block">{{
        item.CreditTicketAmount.toLocaleString("en-US", {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        })
      }}</span>
    </template>

    <template #item.created_at="{ item }">
      <span
        class="d-block mt-1 text-monospace"
        style="font-size: 0.8em; min-width: 140px"
      >{{ $moment(item.created_at).format("YYYY-MM-DD HH:mm:ss") }}</span>
      <v-chip
        pill
        class="pa-1 mb-1"
        x-small
        color="light"
      >
        {{ $moment(item.created_at).fromNow() }}
      </v-chip>
    </template>
  </v-data-table>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';

export default {
  name: 'UserMemberTable',
  props: {
    userId: { required: true, default: null },
  },
  data() {
    return {
      options: {},
      loading: true,
      items: [],
      totalItems: 0,
      headers: [
        {
          text: 'ชื่อสมาชิก',
          value: 'name',
          align: 'center',
          justify: 'center',
        },
        {
          text: 'ยอดแทงทั้งหมด',
          value: 'amount',
          align: 'center',
          justify: 'center',
        },
        { text: 'วันที่สมัคร', value: 'created_at', align: 'center' },
      ],
      footer: {
        disableItemsPerPage: true,
        itemsPerPageOptions: [],
        showCurrentPage: true,
      },
    };
  },
  watch: {
    options: {
      handler() {
        this.fetchData();
      },
      deep: true,
    },
  },
  methods: {
    CancelToken: axios.CancelToken,
    fetchData() {
      if (this.userId) {
        this.loading = true;
        if (this.axiosCanceller) {
          this.axiosCanceler();
        }
        axios
          .get(`/api/user/getUserMember/${this.userId}`, {
            params: {
              page: this.options.page,
            },
            cancelToken: new axios.CancelToken((c) => {
              this.axiosCanceler = c;
            }),
          })
          .then((response) => {
            Vue.set(this, 'items', response.data);
            Vue.set(this, 'totalItems', response.data.total);
            Vue.set(this.options, 'page', response.data.current_page);
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>
